// extracted by mini-css-extract-plugin
export default {"gamePreview":"GamePreview_gamePreview__QWIcD","main":"GamePreview_main__ILZ97","title":"GamePreview_title__dmE+Z","content":"GamePreview_content__LS9Vc"};